<template>
  <a-row :gutter="{xs:0, lg:8}">
    <a-col :xs="24" :lg="8">
      <a-card>
        <span class="m-text-title" slot="title">Filter</span>
        <div class="d-flex flex-column">
          <a-input-search v-model="search" placeholder="Pencarian ... "/>
          <a-collapse activeKey="1" class="m-top">
            <a-collapse-panel key="1">
              <span slot="header">Cari Lebih Lengkap</span>

              <div class="m-form-item-wrapper">
                <label for="tanggalTransaksi">Status</label>
                <a-select
                  placeholder="Ex: Approved ... "
                  v-model="status"
                  class="w-full"
                  allowClear
                >
                  <a-select-option v-for="item in jenis" :key="item.value">{{item.text}}
                  </a-select-option>
                </a-select>
              </div>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </a-card>
    </a-col>
    <a-col :xs="24" :lg="16">
      <H-Datalist
        title="Master Kategori"
        :manifestLink="manifestFor"
        editLink="edit"
        :dataList="basedData"
        :isSpecialMenu="false"
        :isLoading="isLoading"
        :readable="true"
        :extendedButton="true"
      >
        <div slot="action-button">
          <a-button type="primary" @click="handleCreate('create')">
            <a-icon type="plus"/>&nbsp;Kategori
          </a-button>
        </div>
        <template slot="change-button" slot-scope="{item}">
          <a-button  @click="handleUpdate(item)">
            <a-icon type="edit"/>
          </a-button>

          <a-button type="danger" @click="handleDelete(item)">
            <a-icon type="close"/>
          </a-button>
        </template>
      </H-Datalist>
    </a-col>

    <a-modal title="Buat Kategori" :visible="visible" @cancel="handleCancel" :destroyOnClose="true">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Return</a-button>
        <a-button
          key="submit"
          :disabled="disable"
          type="primary"
          :loading="loading"
          @click="handleOk"
        >Submit
        </a-button>
      </template>
      <a-form class="m-form" :form="form">
        <a-form-item label="Jenis">
          <a-select showSearch  :filterOption="filterOption" allowClear  v-decorator="['jenis', {rules: [{required: true}],initialValue: tempUpdateData != null ? tempUpdateData.status : null}]">
            <a-select-option v-for="item in jenis" :key="item.value">{{item.text}}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="Nama Kategori">
          <a-input v-decorator="['nama_kategori', {rules: [{required: true}], initialValue: _.isEmpty(tempUpdateData) ? null : tempUpdateData.title }]" />
        </a-form-item>

        <a-form-item label="Tanggal">
          <a-input-number v-decorator="['tanggal', {rules: [{required: true}], initialValue : _.isEmpty(tempUpdateData) ? null : tempUpdateData.tempDate.tanggal}]" :min="1" :max="31"/>
        </a-form-item>

        <a-form-item label="Bulan">
          <a-month-picker placeholder="Select month"  format="MMMM" v-decorator="['bulan', {rules: [{required: true}], initialValue : _.isEmpty(tempUpdateData) ? null : tempUpdateData.tempDate.bulan == null ? null : moment(tempUpdateData.tempDate.bulan, 'MM') }]"/>
        </a-form-item>

        <a-form-item label="Catatan" >
          <a-textarea
            placeholder="Tulis catatan disini ... "
            :rows="4"
            v-decorator="['catatan', {rules: [{required: false}], initialValue : _.isEmpty(tempUpdateData) ? '' : tempUpdateData.remark}]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-row>
</template>

<script>
    import axios from "axios";
    import {mapGetters} from "vuex";
    import DataList from "@/components/Datalist";
    import moment from "moment";

    export default {
        components: {
            "H-Datalist": DataList
        },
        name: "M.Kategori",
        data() {
            return {
                kategoriList: [],
                visible: false,
                search: "",
                status: "",
                dates: [],
                loading: false,
                disable: false,
                mode: "Create",
                rubahData: {},
                selectAttribute: {
                    dot: true
                },
                id_cuti: "",
                isLoading: false,
                jenis : [],
                tempUpdateData : {},


            };
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        mounted() {
            Event.$on("confirmMessageReturn", this.handleSubmitProcess);
            Event.$on("confirmMessageEdit", this.handleEditProcess);
            Event.$on("confirmMessageDelete", this.handleDeleteProcess);
        },
        beforeDestroy() {
            Event.$off("confirmMessageReturn", this.handleSubmitProcess);
            Event.$off("confirmMessageEdit", this.handleEditProcess);
            Event.$off("confirmMessageDelete", this.handleDeleteProcess);
        },
        created() {
            this.fetchData();
        },

        computed: {
            ...mapGetters([
                "getAuth",
                "getCuti",
                "getDefaultDateFormat",
                "getStandartFormatDate"
            ]),
            basedData() {
                let output = [];

                this.searching.forEach(data => {
                    output.push({
                        title: data.nama_kategori,
                        subdesc: [
                            [
                                {label: "Tanggal", value: data.tanggal == null ? '-':data.tanggal},
                                {label: "Bulan", value: data.bulan == null ? '-': moment(data.bulan, 'MM').format('MMMM') },
                            ]
                        ],
                        tempDate:{tanggal:data.tanggal, bulan: data.bulan},
                        status: data.jenis_kategori,
                        remark : data.remark,
                        id: data.kategori_id,
                    });
                });

                return output;
            },
            manifestFor() {
                let data = "";
                if (this.spesialFor === "Direktur") {
                    data = "dir.mon.manifest.cuti";
                } else if (this.spesialFor === "Atasan Langsung") {
                    data = "al.mon.manifest.cuti";
                } else if (this.spesialFor === "HRD") {
                    data = "hrd.mon.manifest.cuti";
                }
                return data;
            },
            searching() {
                let data = this.kategoriList;

                if (this.search) {
                    data = _.filter(
                        data,
                        obj =>
                            obj.nama_kategori.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
                    );
                }

                if (this.status) {
                    data = _.filter(
                        data,
                        obj =>
                            obj.jenis_kategori &&
                            obj.jenis_kategori.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
                    );
                }

                return data;
            }
        },
        methods: {
            moment,
            async fetchData() {
                this.isLoading = true;

                const jns_kategori = await axios.get(
                    this.$serviceUrl + "kalender/jenis_kategori",
                    {
                        auth: {
                            username: this.getAuth.username,
                            password: this.getAuth.password
                        },
                        headers: {
                            "X-API-KEY": this.getAuth.apikey
                        },
                    }
                );

                const kategori = await axios.get(
                    this.$serviceUrl + "kalender/kategori",
                    {
                        auth: {
                            username: this.getAuth.username,
                            password: this.getAuth.password
                        },
                        headers: {
                            "X-API-KEY": this.getAuth.apikey
                        },
                    }
                );

                await axios({
                    method: "get",
                    url: this.$serviceUrl + "kalender/kategori",
                    auth: {
                        username: this.getAuth.username,
                        password: this.getAuth.password
                    },
                    headers: {
                        "X-API-KEY": this.getAuth.apikey
                    }
                })
                    .then(response => {
                        this.kategoriList = response.data.data;
                        this.isLoading = false;
                    })
                    .catch(err => {
                        this.isLoading = false;
                        return err;
                    });

                Promise.all([jns_kategori, kategori]).then(
                    response => {
                        this.jenis = response[0].data.data;
                        this.kategoriList = response[1].data.data;

                    }
                );
            },

            handleOk() {
                if(this.mode === 'create'){
                    this.confirmMessage("confirm-save");
                }else if(this.mode === 'update'){
                    this.confirmMessage("confirm-edit");
                }
            },
            handleCancel() {
                this.visible = false;
                this.mode = 'create';
                this.tempUpdateData = {};
                // this.dates = [];
                // this.id_cuti = "";
            },
            limaHari(date, days) {
                date = moment(date);
                while (days > 0) {
                    date = date.add(1, "days");
                    if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
                        days -= 1;
                    }
                }
                return date._d;
            },
            handleCreate(){
                this.mode = 'create';
                this.visible = true;
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            handleSubmitProcess(){
                this.form.validateFields((err, values) => {
                    if (err) {
                        return;
                    }
                    let postData = new FormData();
                    postData.append("jenis_kategori", values.jenis);
                    postData.append("nama_kategori", values.nama_kategori);
                    postData.append("tanggal", values.tanggal);
                    postData.append("bulan", values.bulan.month() + 1);
                    if(!_.isNil(values.catatan)){
                        postData.append("remark", values.catatan);
                    }
                    postData.append("tlc_create", this.getAuth.username);

                    axios({
                        method: "post",
                        url: this.$serviceUrl + "kalender/kategori",
                        processData: false,
                        auth: {
                            username: this.getAuth.username,
                            password: this.getAuth.password
                        },
                        headers: {
                            "X-API-KEY": this.getAuth.apikey
                        },
                        data: postData
                    })
                        .then(response => {
                            this.$notification.success({
                                message: "Sukses",
                                description: "Data telah berhasil diproses!"
                            });
                            this.visible = false;
                            this.$router.go();

                        })
                        .catch(err => {
                            if (err.response.data.status === false) {
                                this.$notification.error({
                                    message: "Error",
                                    description: err.response.data.message
                                });
                            }
                        });

                });


            },
            handleUpdate(item){

                this.mode = 'update'
                this.visible = true;
                this.tempUpdateData = item;
            },
            handleDelete(item){
                this.confirmMessageValue("confirm-delete",item);
            },
            handleEditProcess(){
                this.form.validateFields((err, values) => {
                    if (err) {
                        return;
                    }
                    let postData = new FormData();
                    postData.append("jenis_kategori", values.jenis);
                    postData.append("nama_kategori", values.nama_kategori);
                    postData.append("tanggal", values.tanggal);
                    postData.append("bulan", values.bulan.month() + 1);
                    if(!_.isNil(values.catatan)){
                        postData.append("remark", values.catatan);
                    }
                    postData.append("tlc_create", this.getAuth.username);
                    postData.append("kategori_id", this.tempUpdateData.id);

                    axios({
                        method: "post",
                        url: this.$serviceUrl + "kalender/kategori_edit",
                        processData: false,
                        auth: {
                            username: this.getAuth.username,
                            password: this.getAuth.password
                        },
                        headers: {
                            "X-API-KEY": this.getAuth.apikey
                        },
                        data: postData
                    })
                        .then(response => {
                            this.$notification.success({
                                message: "Sukses",
                                description: "Data telah berhasil diubah!"
                            });
                            this.visible = false;
                            this.$router.go();

                        })
                        .catch(err => {
                            if (err.response.data.status === false) {
                                this.$notification.error({
                                    message: "Error",
                                    description: err.response.data.message
                                });
                            }
                        });

                });

            },
            handleDeleteProcess(item){
                axios({
                    method: "post",
                    url: this.$serviceUrl + "kalender/kategori_delete",
                    processData: false,
                    auth: {
                        username: this.getAuth.username,
                        password: this.getAuth.password
                    },
                    headers: {
                        "X-API-KEY": this.getAuth.apikey
                    },
                    data: {kategori_id  : item.id}
                })
                    .then(response => {
                        this.$notification.success({
                            message: "Sukses",
                            description: response.data.message
                        });
                        this.visible = false;
                        this.$router.go();
                    })
                    .catch(err => {
                        if (err.response.data.status === false) {
                            this.$notification.error({
                                message: "Error",
                                description: err.response.data.message
                            });
                        }
                    });
            }
        }
    };
</script>

<style>
</style>
